module.exports = __webpack_public_path__ + "static/cover-fc7be9a551c7f84bea96b0add56fefea.jpg";